import React from 'react'
import Pack from './Packs';

const sony = [
    { cclass: "sony-set", cname: "Sony Set"},
    { cclass: "sony-sab", cname: "Sony Sab"},
    { cclass: "set-max", cname: "Set Max"},
    { cclass: "max2", cname: "Max 2"},
    { cclass: "sony-wah", cname: "Sony Wah"},
    { cclass: "sony-yay", cname: "Sony Yay"},
    { cclass: "sony-mix", cname: "Sony Mix"},
    { cclass: "sony-marathi", cname: "Sony Marathi"},
    { cclass: "sony-pal", cname: "Sony Pal"},
    { cclass: "sony-ten3", cname: "Sony Ten3"},
    { cclass: "sony-bbc-earth", cname: "BBC Earth"},
];
const colors = [
    { cclass: "colors-marathi", cname: "Colors Marathi"},
    { cclass: "news18-lokmat", cname: "News18 Lokmat"},
    { cclass: "cnbc-awaaz", cname: "CNBC Awaaz"},
    { cclass: "colors", cname: "Colors"},
    { cclass: "nickjr", cname: "Nick Jr"},
    { cclass: "news18-urdu", cname: "News18 Urdu"},
    { cclass: "fyi-tv18", cname: "FYI Tv 18"},
    { cclass: "history", cname: "History"},
    { cclass: "mtv", cname: "MTV"},
    { cclass: "mtv-beats", cname: "MTV Beats"},
    { cclass: "news18-india", cname: "News18 India"},
    { cclass: "rishtey", cname: "Rishtey"},
    { cclass: "rishtey-cineplex", cname: "Rishtey Cineplex"},
    { cclass: "vh1", cname: "VH1"},
    { cclass: "nick", cname: "Nick"},
    { cclass: "sonic", cname: "Sonic"},
];
const star = [
      {cclass: "star-plus", cname: "Star Plus"},
      {cclass: "star-bharat", cname: "Star Bharat"},
      {cclass: "star-utsav", cname: "Star Utsav"},
      {cclass: "star-gold", cname: "Star Gold"},
      {cclass: "movies-ok", cname: "Movies Ok"},
      {cclass: "star-utsav-movies", cname: "Star Utsav Moies"},
      {cclass: "star-sports1-hindi", cname: "Star sports1 hindi"},
      {cclass: "star-sport2", cname: "Star sports2"},
      {cclass: "star-sport3", cname: "Star sport3"},
      {cclass: "star-sport-first", cname: "Star sport first"},
      {cclass: "natgeo", cname: "National Geographic"},
      {cclass: "netgeo-wild", cname: "Nat Geo Wild"},
      {cclass: "star-pravah", cname: "Star Pravah"},
];

const zee = [
      { cclass: "z-tv", cname: "Zee Tv"},
      { cclass: "and-tv", cname: "& Tv"},
      { cclass: "z-anmol", cname: "Zee Anmol"},
      { cclass: "big-magic", cname: "Big Magic"},
      { cclass: "z-cinema", cname: "Zee Cinema"},
      { cclass: "and-pictures", cname: "& Pictures"},
      { cclass: "z-bollywood", cname: "Zee Bollywood"},
      { cclass: "z-action", cname: "Zee Action"},
      { cclass: "z-anmol-cinema", cname: "Zee Anmol Cinema"},
      { cclass: "z-news", cname: "Zee News"},
      { cclass: "z-hindustan", cname: "Zee Hindustan"},
      { cclass: "z-bsns", cname: "Zee Business"},
      { cclass: "z-etc", cname: "Zee Etc"},
      { cclass: "zing", cname: "Zing"},
      { cclass: "z-marathi", cname: "Zee Marathi"},
      { cclass: "z-talkies", cname: "Zee Talkies"},
      { cclass: "z-yuva", cname: "Zee Yuva"},
      { cclass: "z-24taas", cname: "Zee 24 Taas"},
      { cclass: "ezmall", cname: "EZ Mall"},
      { cclass: "z-salaam", cname: "Zee Salaam"},
      { cclass: "liv-food", cname: "Living Food"},
];

const sp1 = [
    { cclass: "sp1", cname: "" },
{ cclass: "sp2", cname: "" },
{ cclass: "sp3", cname: "" },
{ cclass: "sp4", cname: "" },
{ cclass: "sp5", cname: "" },
{ cclass: "sp6", cname: "" },
{ cclass: "sp7", cname: "" },
{ cclass: "sp8", cname: "" },
{ cclass: "sp9", cname: "" },
{ cclass: "sp10", cname: "" },
{ cclass: "sp11", cname: "" },
{ cclass: "sp12", cname: "" },
{ cclass: "sp13", cname: "" },
{ cclass: "sp14", cname: "" },
{ cclass: "sp15", cname: "" },
{ cclass: "sp16", cname: "" },
{ cclass: "sp17", cname: "" },
{ cclass: "sp18", cname: "" },
{ cclass: "sp19", cname: "" },
{ cclass: "sp20", cname: "" },
{ cclass: "sp21", cname: "" },
{ cclass: "sp22", cname: "" },
{ cclass: "sp23", cname: "" },
{ cclass: "sp24", cname: "" },
{ cclass: "sp25", cname: "" },
{ cclass: "sp26", cname: "" },
{ cclass: "sp27", cname: "" },
{ cclass: "sp28", cname: "" },
{ cclass: "sp29", cname: "" },
{ cclass: "sp30", cname: "" },
{ cclass: "sp31", cname: "" },
{ cclass: "sp32", cname: "" },
{ cclass: "sp33", cname: "" },
{ cclass: "sp34", cname: "" },
{ cclass: "sp35", cname: "" },
{ cclass: "sp36", cname: "" },
{ cclass: "sp37", cname: "" },
{ cclass: "sp38", cname: "" },
{ cclass: "sp39", cname: "" }
];

export default class AllPacks extends React.Component{
    // constructor(props){
    // super(props)
    // this.state = {
    //     inds: []
    // }
    //     for (let index = 1; index < 40; index++) {
    //         this.state.inds.push(index);
    //     }
    // }
    render(){
        
        return (
            <div className="pack-bg">
            {/* {
                this.state.inds.map(t => (
                    <p>.sp{t} &#123;  
                        background: #fff url(imgs/sp1/{t}.jpg) no-repeat !important;
                    }
                    </p>
                )) */}
            
            <Pack 
                title="Sony Channel Bouquet"
                clist={sony}
            />

            <Pack 
                title="Colors Channel Bouquet"
                clist={colors}
            />

            <Pack 
                title="Star Channel Bouquet"
                clist={star}
            />

            <Pack 
                title="Zee Channel Bouquet"
                clist={zee}
            />

            <Pack 
                title="Channel Pack 1"
                clist={sp1}
            />
            </div>
        );
    }
}